import React, {useEffect, useMemo, useState} from 'react';
import Marker from "../icons/Marker";
import {Popover} from "antd";
import '../styles/Highlighter.scss'
import {Colors} from "../../../../styles/Colors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {GlobalConsts} from "../../../../styles/GlobalConsts";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {$getSelection, $isRangeSelection, $isTextNode} from "lexical";
import {$createHighlightNode, $isHighlightNode} from "../nodes/HighlightNode";

const HighlighterPlugin = (props) => {
    const [selection, setSelection] = useState('none');
    const [editor] = useLexicalComposerContext();

    const colors = useMemo(() => {
        return Object.entries(Colors.highlighterColors).reduce((arr, [key, color]) => [...arr, {id: key, color: color, selected: key === selection}], [])
    }, [selection]);

    useEffect(() => {
        return editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => getHighlightColor());
        });
    }, [editor]);

    //NOTE: this is mainly claude code, with some logic fixes by me (eden) please don't change anything here (also, foreach didn't work so for loop it is)
    const handleColorSelection = (colorId) => {
        editor.update(() => {
            const selection = $getSelection();
            if (!$isRangeSelection(selection)) return; // No text selected, or wrong selection type
            if (selection.isCollapsed()) return; // Cursor is just positioned, no text selected
            const nodes = selection.extract(); // Get all nodes in the selection
            for (let i = 0; i < nodes.length; i++) {
                let node = nodes[i]
                if ($isHighlightNode(node)) {  // Update existing highlight
                    node.setHighlight(colorId);
                } else if ($isTextNode(node)) { // Convert regular text to highlighted text
                    const highlightNode = $createHighlightNode(node.getTextContent(), colorId);
                    highlightNode.setFormat(node.getFormat()); // Preserve bold/italic
                    node.replace(highlightNode);
                }
            }
        });
    };

    const getHighlightColor = () => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return null; // No selection

        const nodes = selection.getNodes(); // Get nodes in selection
        const highlightNode = nodes.find(node => $isHighlightNode(node));

        const highlight =  highlightNode ? highlightNode.getHighlight() : null;
        setSelection(highlight || 'none');

    }

    const content = () => {
        return (
            <div className={'colors-wrapper'}>
                {colors.map(color => (
                    <div onClick={() => handleColorSelection(color.id)} className={`color-item ${color.selected ? 'active' : ''}`} style={{backgroundColor: color.color}} key={color.id}>
                        {color.id === 'none' && <FontAwesomeIcon icon={light('droplet-slash')} fontSize={GlobalConsts.iconSize.XXS} color={Colors.newDesign.mainText}/>}
                    </div>
                ))}
            </div>)
    }

    return (
        <Popover content={content()} trigger="click" arrow={false} placement={'bottom'} id={'custom-highlighter-popover'}>
            <div className={`marker-btn simple-action-button`}>
                <Marker/>
                <div className={'marker-color'} style={{backgroundColor: Colors.highlighterColors[selection ?? 'none']}}/>
            </div>
        </Popover>
    );
};

export default HighlighterPlugin;